module.exports = __webpack_public_path__ + "static/fonts/f4769f9bdb7466be65088239c12046d1.eot";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.eot
// module id = 844
// module chunks = 0